<template>
  <div class="CompanyProfile">
    <!-- 公司简介 -->
    <div class="c-box box-company-profile wow fadeInUp animated">
      <div class="b_space_text_v">
        <div class="b_space_text" ref="memberContent">
          <div class="b_title">
            <div class="t_cn">{{ enterpriseObj.synopsisTitle }}</div>
            <div class="t_en">
              <i class="unLine"></i>
              <span>COMPANY PROFILE</span>
            </div>
          </div>
          <div class="b_content" v-html="enterpriseObj.synopsis">
            <!-- <p class="c_text">
            梧州黄埔化工药业有限公司（以下简称：梧州黄埔）前身为“广州黄埔化工有限公司”，
            2011年根据广州市“退二进三”的战略部署，从广州迁址到广西梧州，于2010年10月注册成立，注册地址位于梧州市万秀区梧松路1号，注册资本1.95亿元（2021年增资扩股）。2013年9月梧州黄埔年产3000吨合成樟脑、800吨冰片项目于梧州市松脂产业园区建成试生产。梧州黄埔现为广州工业投资控股集团有限公司属下国有全资企业，于2021年4月收购了广西梧州日成林产化工股份有限公司70%股权，属下还有梧州市日成太平林产化工有限公司、岑溪东林松香有限公司2个独资子公司。梧州黄埔本部占地面积55亩、建筑面积22000平方米，有员工210余人；属下企业占地面积229亩、建筑面积约31000平方米，有员工280余人。
          </p>
          <p class="c_text">
            作为合成樟脑和冰片原料药的传统生产企业，梧州黄埔是世界上较早以化学合成工艺生产冰片和国内较早能按各国药典标准生产药用级樟脑的厂家。主要产品“白雪”牌冰片有70多年的生产历史，拳头产品“广达”牌合成樟脑更是享誉国内外，深受客户青睐，在1980年、1986年获广东省优质产品称号，1982年荣获国家化工部优质产品称号。除此还可生产莰烯、双戊烯、醋酸异龙脑酯、醋酸钠、α-蒎烯、β-蒎烯等不同品种、规格的产品。获得药品生产许可证、ISO质量管理体系认证、ISO环境管理体系认证、冰片（合成龙脑）注册证、樟脑（合成）等资质；拥有有效专利11项，其中发明专利2项，实用型专利7项，外观专利2项。
          </p>
          <p class="c_text">
            跨越七十余载春秋，历经涅槃重生。十年来，梧州黄埔以搬迁作为转型升级的契机，发扬优秀传统，优化生产工艺，不断拓宽成长之路，在产学研融合发展、客户合作和市场开拓、助力地方社会经济方面获得提升，收到了较好的经济效益和社会效益。近年来先后通过梧州市农业产业化重点龙头企业认定、广西自治区级林业产业重点龙头企业认定、广西自治区高新技术企业认定等，获得2017、2018年度梧州市出口先进企业、2019年度梧州市成长型企业等荣誉称号。
          </p>
          <p class="c_text">
            梧州黄埔将永远秉持“质量第一，守法经营，顾客至上”的方针，竭尽所能满足客户的各项需求，继续为做大做强做优国有企业而不懈奋斗；以继承公司创始人陈秋安先生振兴中华、实业报国的初心为使命，以打造“全球最好的药用级樟脑，最具品牌影响力的冰片”为目标，为万民健康保驾护航，为民族品牌砥砺前行。
          </p> -->
          </div>
          <div class="b_data clear">
            <div
              class="data_item"
              v-for="(item, index) in enterpriseExpandObj"
              :key="'data_item' + index"
            >
              <div class="item_num">
                <span class="i_data">
                  <animate-number
                    class="i_data"
                    ref="myNum"
                    from="1"
                    mode="manual"
                    :to="item.year"
                  ></animate-number
                ></span>
                <span class="i_danwei">{{ item.content }}</span>
              </div>
              <div class="item_tit">
                <span class="data_txt">{{ item.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="b_space_img">
        <div class="s_bigImg clear">
          <div class="item_img item_img1">
            <img :src="enterpriseObj.imageUrl" alt="company_img1" />
          </div>
          <div class="item_img item_img2">
            <img :src="videoImageUrl" alt="company_img2" />
            <div class="btn-play" @click="OnShowVideo"></div>
          </div>
        </div>
        <div
          class="s_environmentImg clear"
          v-if="environmentImgList.length > 0"
        >
          <swiperCpt
            class="wow fadeInUp animated"
            ref="environmentImgSwiper"
            :delay="5000"
            :loop="environmentImgList.length > 3"
            :autoplay="environmentImgList.length > 3"
            sid="environmentImgSwiper"
            :slidesPerView="4"
          >
            <div
              class="swiper-slide"
              v-for="(item, index) in environmentImgList"
              :key="index"
            >
              <div class="environmentImg">
                <div class="box_img">
                  <img
                    :src="item.imageUrl"
                    :large="item.imageUrl"
                    preview="environmentImg"
                    :preview-text="item.imageName"
                    :alt="'environmentImg' + index"
                  />
                </div>

                <div class="imgDesc textSl1">{{ item.imageName }}</div>
              </div>
            </div>
          </swiperCpt>
          <div
            class="swiperBtn swiperBtn_left"
            @click="$refs.environmentImgSwiper.swiperSl.swipePrev()"
          ></div>
          <div
            class="swiperBtn swiperBtn_right"
            @click="$refs.environmentImgSwiper.swiperSl.swipeNext()"
          ></div>
        </div>
      </div>
    </div>
    <!-- 品牌简介 -->
    <div class="c-box box-brand-profile wow fadeInUp animated">
      <div class="b_title">
        <div class="t_cn">公司旗下品牌简介</div>
        <div class="t_en">
          <i class="unLine"></i>
          <span>BRAND PROFILE</span>
        </div>
      </div>
      <div class="BrandList clear">
        <div
          class="item_Brand"
          v-for="(item, index) in brandList"
          :key="'item_Brand' + index"
        >
          <router-link :to="item.retainfield2">
            <div class="i_cont">
              <img :src="item.imageUrl" alt="BrandImg1" />
              <div class="i_title">{{ item.imageName }}</div>
            </div>
            <div class="i_info">
              <div class="i_tit">{{ item.imageName }}</div>
              <i></i>
              <div class="i_text">{{ item.imageDesc }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- 企业优势 -->
    <div class="c-box box-enterprise-advantage wow fadeInUp animated">
      <div class="b_cont">
        <div class="b_title">
          <div class="t_cn">企业优势</div>
          <div class="t_en">
            <i class="unLine"></i>
            <span>ENTERPRISE ADVANTAGE</span>
          </div>
        </div>
        <div class="advantageList clear" v-if="advantageList.length > 0">
          <div
            class="item_advantage"
            v-for="(item, index) in advantageList"
            :key="index"
          >
            <img
              class="i_icon"
              :src="item.imageUrl"
              :alt="'item_advantage' + index"
            />
            <div class="i_title">{{ item.imageName }}</div>
            <i></i>
            <div class="i_desc">{{ item.imageDesc }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="c-box box-cooperative-partner wow fadeInUp animated">
      <div class="decoration1"></div>
      <div class="b_title">
        <div class="t_cn">合作伙伴</div>
        <div class="t_en">
          <i class="unLine"></i>
          <span>COOPERATIVE PARTNER</span>
        </div>
      </div>
      <div class="cont">
        <img
          src="../../assets/images/company/CompanyProfile/partnerBg.png"
          alt="合作伙伴"
        />
      </div>
    </div>
    <VideoModel
      ref="InfoVideoModel"
      :isShowVideo.sync="isShowVideo"
      :videoSrc="videoSrc"
    ></VideoModel>
  </div>
</template>

<script>
import swiperCpt from "@/components/common/swiperCpt.vue";
import VideoModel from "@/components/common/VideoModel.vue";
if (process.browser) {
  var { WOW } = require("wowjs");
}
export default {
  name: "CompanyProfile",
  data() {
    return {
      showTip: false,
      // infoList: [
      //   {
      //     infoTxt: "历史底蕴",
      //     infoNum: 72,
      //     infoUnit: "年",
      //   },
      //   {
      //     infoTxt: "荣誉资质",
      //     infoNum: 13,
      //     infoUnit: "项+",
      //   },
      //   {
      //     infoTxt: "企业占地面积",
      //     infoNum: 55,
      //     infoUnit: "亩",
      //   },
      //   {
      //     infoTxt: "建筑面积",
      //     infoNum: 22000,
      //     infoUnit: "㎡",
      //   },
      //   {
      //     infoTxt: "年产樟脑",
      //     infoNum: 3000,
      //     infoUnit: "吨",
      //   },
      //   {
      //     infoTxt: "公司员工",
      //     infoNum: 200,
      //     infoUnit: "名",
      //   },
      // ],
      environmentImgList: [],
      // brandList: [
      //   {
      //     id: 0,
      //     logoSrc: require("../../assets/images/company/CompanyProfile/BrandImg1.png"),
      //     title: "广达牌樟脑",
      //     info: "广达牌樟脑介绍",
      //     desc: "本品为白色结晶性粉末或无色半透明的硬块，味初辛、后清凉；主要用作医药原料，如皮肤刺激药、生产樟脑磺酸钠。",
      //   },
      //   {
      //     id: 1,
      //     logoSrc: require("../../assets/images/company/CompanyProfile/BrandImg2.png"),
      //     title: "白雪牌冰片",
      //     info: "白雪牌冰片介绍",
      //     desc: "本品为无色透明或半透明的片状松脆结晶；气清香，味辛、凉；在中医药中用于治疗热病神昏、惊厥、中风痰厥、气郁暴厥、中恶昏迷、目赤、口疮、咽喉肿痛、耳道流脓等症状，冰片还是良好的食品、日常护理品和香精香料的原料。",
      //   },
      //   {
      //     id: 4,
      //     logoSrc: require("../../assets/images/company/CompanyProfile/BrandImg3.png"),
      //     title: "三春牌醋酸钠",
      //     info: "三春牌醋酸钠介绍",
      //     desc: "本产品为无色或白色晶体，暴露于潮湿空气中易潮解，于干燥空气中易风化。主要用于印染工业、医药、照相、电镀、化学试剂及有机合成的生产等。",
      //   },
      // ],
      brandList: [],
      // advantageList: [
      //   {
      //     iconSrc: require("../../assets/images/company/CompanyProfile/advantage_icon1.png"),
      //     title: "品牌历史悠久",
      //     desc: "梧州黄埔公司主要产品“白雪”牌冰片有70多年的生产历史，拳头产品“广达”牌合成樟脑于1968年开始生产，享誉国内外，深受客户青睐，在1980年、1986年获广东省优质产品称号，1982年荣获国家化工部优质产品称号。黄埔化工是世界上较早以化学合成工艺生产冰片和国内较早能按各国药典标准生产药用级樟脑的生产厂家。",
      //   },
      //   {
      //     iconSrc: require("../../assets/images/company/CompanyProfile/advantage_icon2.png"),
      //     title: "众多荣誉资质",
      //     desc: "企业荣誉资质主要有：广西自治区高新技术企业、广西林业产业重点龙头企业、梧州市农业产业化重点龙头企业、2019年度梧州市成长型企业、2019年度纳税信用等级A级纳税人，2017、2018年度梧州市出口先进企业，安全生产标准化二级企业，知识产权贯标认证企业。",
      //   },
      //   {
      //     iconSrc: require("../../assets/images/company/CompanyProfile/advantage_icon3.png"),
      //     title: "培育研发人才",
      //     desc: "企业建立了长远的人才培养机制，定期制定培训方案。培训的形式多样化，包括有脱产培训、现场培训、跟岗实习、技术交流等；培训种类全面，有特种作业、岗位培训、专业技能、管理技能及任职资格等；在培训结束后做到及时总结、分析及改进，促进员工不断进步。技术人员的提升方面，我们与国内高校广泛开展校企合作，建立了产学研实习基地，为企业产品的技术创新提供新方向。",
      //   },
      // ],
      advantageList: [], // 企业优势
      enterpriseObj: {}, // 企业信息
      enterpriseExpandObj: [], //企业信息拓展
      // 视频是否播放
      isShowVideo: false,
      videoSrc: "",
      videoImageUrl: require("../../assets/images/company/CompanyProfile/company_img2.png"),
      environmentImgPageSize: 100000,
    };
  },
  // created() {
  //   // 循环录入园区环境图片
  //   for (let i = 1; i <= 23; i++) {
  //     this.environmentImgList.push({
  //       imgSrc: require("../../assets/images/company/CompanyProfile/environmentImg" +
  //         i +
  //         ".png"),
  //         imgBigSrc: require("../../assets/images/company/CompanyProfile/environmentImg" +
  //         i +
  //         "-1.jpg"),
  //       text: "园区环境",
  //     });
  //   }
  // },
  mounted() {
    if (process.browser) {
      new WOW({
        live: false,
        offset: 0,
      }).init();
    }
    this.showTip = true;
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScroll); // 监听（绑定）滚轮滚动事件
    });
    this.getEnterprise();
    this.getEnterpriseExpand();
    this.getEnvironmentImgList();
    this.getBusinessAdvantage();
    this.getAboutusMemorabilia();
    this.getProductList();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 监听滚动条高度
    handleScroll() {
      let scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop; //滚动高度
      let boxHeight = 0;
      boxHeight = this.$refs.memberContent.clientHeight; //盒子高度
      if (boxHeight - scrollHeight <= 30) {
        this.showTip = true;
      } else {
        this.showTip = false;
      }
    },
    // 获取公司环境图片
    async getEnvironmentImgList() {
      let res = await this.$request.getImageManageList({
        columnType: "4",
        pageSize: this.environmentImgPageSize,
      });
      if (res.code === 200) {
        res.rows.map((item, index) => {
          item.imageUrl = this.$store.state.baseUrl + item.imageUrl;
        });
        this.environmentImgList = res.rows;

        // 大图预览功能重置刷新
        this.$previewRefresh();
      }
    },
    // 获取公司企业优势
    async getBusinessAdvantage() {
      let res = await this.$request.getImageManageList({
        columnType: "5",
        pageSize: 100000,
      });
      if (res.code === 200) {
        res.rows.map((item, index) => {
          item.imageUrl = this.$store.state.baseUrl + item.imageUrl;
        });
        this.advantageList = res.rows;
      }
    },
    // 获取公司详情
    async getEnterprise() {
      let res = await this.$request.getEnterpriseById({
        enterpriseId: "e230b713-95c4-40c0-89de-f73d645e25a0",
      });
      // console.log("获取公司详情");
      // console.log(res.data);
      res.data.imageUrl = this.$store.state.baseUrl + res.data.imageUrl;
      this.enterpriseObj = res.data;
    },
    // 获取公司拓展详情
    async getEnterpriseExpand() {
      let res = await this.$request.getEnterpriseExpand();
      this.enterpriseExpandObj = res.rows;
      res.rows.map((val, index) => {
        val.year = parseInt(val.year);
      });
      this.$nextTick(() => {
        this.$refs.myNum.map((item) => {
          item.start();
        });
      });

      // console.log(this.enterpriseExpandObj);
    },
    // 获取公司视频
    async getAboutusMemorabilia() {
      let res = await this.$request.getAboutusMemorabilia();
      // console.log("获取公司视频");
      // console.log(res);
      this.videoImageUrl =
        this.$store.state.baseUrl + res.enterpriseVideos[0].imageUrl;
      this.videoSrc =
        "https://gcec-shuichuli-prod.oss-cn-shenzhen.aliyuncs.com/Video/%E6%A2%A7%E5%B7%9E%E9%BB%84%E5%9F%94_v03%EF%BC%88200M%EF%BC%8920220314172337.mp4";
      // this.$store.state.baseUrl + res.enterpriseVideos[0].videoUrl;
    },
    // 获取品牌家族
    async getProductList() {
      let res = await this.$request.getImageManageList({
        columnType: 1,
        pageSize: 100000,
      });
      // 图片增加相关域名
      res.rows.map((item, index) => {
        item.imageUrl = this.$store.state.baseUrl + item.imageUrl;
      });
      this.brandList = res.rows;
      // console.log(res.rows);
    },
    OnShowVideo() {
      this.$refs.InfoVideoModel.OnShowVideo();
    },
  },
  watch: {
    showTip(newval, oldval) {
      if (newval && this.$refs.myNum) {
        this.$refs.myNum.map((item) => {
          item.start();
        });
      }
    },
  },
  components: { swiperCpt, VideoModel },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";
$LiWidth: 3.85vw;
.CompanyProfile {
  width: 100%;
  // overflow: hidden;
  position: relative;
  .c-box {
    .b_title {
      position: relative;
      .t_cn {
        font-size: 1.25vw;
        line-height: 2.08vw;
        color: #333333;
      }
      .t_en {
        height: 1.56vw;
        padding: 1.04vw 0;
        position: relative;
        i {
          position: absolute;
          top: 50%;
          left: 0;
          margin: -0.21vw 0 0 0;
        }
        span {
          font-size: 0.94vw;
          line-height: 1.56vw;
          color: #666666;
          padding: 0 0 0 4.17vw;
        }
      }
    }
  }
  .box-company-profile {
    position: relative;
    .b_space_text_v {
      background: #f0f0f0
        url("../../assets/images/company/CompanyProfile/infoBg.png") bottom
        center no-repeat;
      background-size: 100% auto;
    }
    .b_space_text {
      width: $contWidth;
      min-height: 30.42vw;
      margin: 0 auto;
      box-sizing: border-box;
      padding: 1.56vw 0 2.08vw 0;
      position: relative;
      // &::before {
      //   content: "";
      //   display: block;
      //   width: 100vw;
      //   // min-width: 1920px;
      //   height: 100%;
      //   position: absolute;
      //   bottom: 0;
      //   left: 50%;
      //   z-index: -1;
      //   transform: translate(-50%, 0);
      //   background: #f0f0f0
      //     url("../../assets/images/company/CompanyProfile/infoBg.png") bottom
      //     center no-repeat;
      //   background-size: 100% auto;
      // }
      .b_content {
        padding: 0 0 1.04vw 0;
        font-size: 0.83vw;
        text-indent: 1.88vw;
        line-height: 1.56vw;
        .c_text,
        /deep/ div {
          font-size: 0.83vw;
          text-indent: 1.88vw;
          line-height: 1.56vw;
          color: #333333;
          text-align: justify;
          word-break: normal;
        }
      }
      .b_data {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        position: relative;
        .data_item {
          flex: 1;
          position: relative;
          text-align: center;
          .item_tit {
            height: 1.56vw;
            margin: 0 auto;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            .data_txt {
              display: block;
              font-size: 0.94vw;
              line-height: 1.56vw;
              color: #333333;
            }
          }
          .item_num {
            width: 100%;
            text-align: center;
            // padding: 0.52vw 0 0 0;
            .i_data {
              font-size: 1.88vw;
              font-weight: bold;
              color: #83bb26;
            }
            .i_danwei {
              padding: 0 0 0 0.31vw;
              font-size: 1.04vw;
              font-weight: bold;
              color: #83bb26;
            }
          }
        }
      }
    }
    .b_space_img {
      width: $contWidth;
      margin: 0 auto;
      .s_bigImg {
        padding: 2.08vw 0;
        .item_img {
          float: left;
          position: relative;
          &.item_img1 {
            width: 39.17vw;
            height: 18.85vw;
          }
          &.item_img2 {
            width: 32.19vw - 0.72vw;
            height: 18.85vw - 0.72vw;
            margin: 0 0 0 1.56vw;
            border: 0.36vw solid #eeeeee;
            cursor: pointer;
            object-fit: cover;
            &:hover {
              border: 0.36vw solid $ThemeColor;
            }
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .btn-play {
            display: block;
            width: 1.88vw;
            height: 1.88vw;
            position: absolute;
            top: 50%;
            left: 50%;
            margin: -0.94vw 0 0 -0.94vw;
            border: solid 0.05vw #008737;
            border-radius: 50%;
            background: url("../../assets/images/company/CompanyProfile/btn-paly.png")
              no-repeat;
            background-size: 100%;
          }
        }
      }
      .s_environmentImg {
        position: relative;
        width: 73.75vw;
        min-height: 16.25vw;
        .environmentImg {
          margin: 0 0.78vw 0 0;
          cursor: pointer;
          &:hover {
            .box_img img {
              transform: scale(1.1, 1.1);
            }
            .imgDesc {
              color: #ffffff;
              background-color: $ThemeColor;
            }
          }
          .box_img {
            width: 100%;
            height: 13.33vw;
            overflow: hidden;
            img {
              width: 100%;
              display: block;
              transition: 0.6s ease-in-out;
            }
          }
          .imgDesc {
            width: 100%;
            height: 2.92vw;
            line-height: 2.92vw;
            text-indent: 1.04vw;
            font-size: 0.83vw;
            color: #333333;
            text-align: center;
            background-color: #eeeeee;
          }
        }
        .swiperBtn {
          width: 2.08vw;
          height: 3.65vw;
          cursor: pointer;
          position: absolute;
          top: 50%;
          margin-top: -1.82vw;
          z-index: 66;
          &.swiperBtn_left {
            left: 0;
            background: rgba($color: #c2c3be, $alpha: 0.5)
              url("../../assets/images/common/btn_left.png");
            background-size: cover;
            &:hover {
              background: rgba($color: #fff, $alpha: 0.5)
                url("../../assets/images/common/btn_left.png");
              background-size: cover;
            }
          }
          &.swiperBtn_right {
            right: 0.83vw;
            background: rgba($color: #c2c3be, $alpha: 0.5)
              url("../../assets/images/common/btn_right.png");
            background-size: cover;
            &:hover {
              background: rgba($color: #fff, $alpha: 0.5)
                url("../../assets/images/common/btn_right.png");
              background-size: cover;
            }
          }
        }
      }
    }
  }
  .box-brand-profile {
    width: $contWidth;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 2.08vw 0 2.08vw 0;
    .BrandList {
      position: relative;
      .item_Brand {
        $item_Brand_width: 23.18vw;
        $item_Brand_height: 12.81vw;
        float: left;
        width: $item_Brand_width;
        height: $item_Brand_height;
        margin: 0 1.56vw 1.04vw 0;
        position: relative;
        cursor: pointer;
        &:nth-child(3n) {
          margin: 0 0 0 0;
        }
        &:hover {
          .i_info {
            z-index: 66;
          }
        }
        .i_cont {
          width: $item_Brand_width - 4.17vw;
          height: $item_Brand_height - 3.13vw;
          padding: 1.56vw 2.08vw;
          position: absolute;
          top: 0;
          left: 0;
          background-color: #eeeeee;
          img {
            display: block;
            height: 3.8vw;
            margin: 1.04vw auto 0;
          }
          .i_title {
            padding: 1.56vw 0 0 0;
            font-size: 1.25vw;
            color: #333333;
            text-align: center;
          }
        }
        .i_info {
          width: $item_Brand_width - 4.17vw;
          height: $item_Brand_height - 3.13vw;
          padding: 1.56vw 2.08vw;
          position: absolute;
          top: 0;
          left: 0;
          z-index: -6;
          background-color: #87c31e;
          i {
            display: block;
            width: 2.08vw;
            height: 0.31vw;
            background-color: #ffffff;
            border-radius: 0.16vw;
            margin: 0.83vw 0 1.35vw;
          }
          .i_tit {
            color: #ffffff;
            font-size: 1.25vw;
            line-height: 1.56vw;
          }
          .i_text {
            color: #ffffff;
            font-size: 0.83vw;
            line-height: 1.25vw;
          }
        }
      }
    }
  }
  .box-enterprise-advantage {
    min-height: 31.56vw - 2.08vw;
    padding: 2.08vw 0 0 0;
    position: relative;
    background: url("../../assets/images/company/CompanyProfile/advantageBg.png")
      top center no-repeat;
    background-size: 100%;
    .b_cont {
      width: $contWidth;
      margin: 0 auto;
      .advantageList {
        .item_advantage {
          float: left;
          width: 23.18vw - 3.54vw;
          min-height: 21.35vw - 4.17vw;
          padding: 2.08vw 1.77vw;
          margin: 0 1.56vw 0 0;
          background-color: #ffffff;
          border-radius: 1.56vw 0vw 1.56vw 0vw;
          &:nth-child(3n) {
            margin: 0;
          }
          i {
            display: block;
            width: 1.88vw;
            height: 0.26vw;
            background-color: #87c31e;
            border-radius: 0.16vw;
            margin: 1.04vw 0 1.56vw;
          }
          .i_icon {
            display: block;
            width: 2.81vw;
            padding: 0 0 1.04vw 0;
          }
          .i_title {
            font-size: 1.25vw;
            line-height: 1.56vw;
            color: #333333;
          }
          .i_desc {
            font-size: 0.83vw;
            line-height: 1.25vw;
            text-indent: 1.67vw;
            color: #666666;
            text-align: justify;
            display: -webkit-box;
            text-overflow: ellipsis; /*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 8;
            overflow: hidden;
          }
        }
      }
    }
  }
  .box-cooperative-partner {
    width: $contWidth;
    margin: 0 auto;
    padding: 2.08vw 0 3.13vw 0;
    position: relative;
    .decoration1 {
      display: block;
      width: 2.34vw;
      height: 2.34vw;
      border-radius: 50%;
      border: 1.04vw solid #ffb103;
      position: absolute;
      top: -2.24vw;
      right: 0;
      z-index: 6;
    }
    .cont {
      margin: 3.13vw 0 0 0;
      min-height: 16.77vw;
      position: relative;
      img {
        width: 100%;
      }
    }
  }

  .unLine {
    display: flex;
    width: $LiWidth;
    height: 0.21vw;
    box-sizing: border-box;
    position: relative;
    &::before {
      content: "";
      display: block;
      width: 0.42vw;
      height: 0.21vw;
      border-radius: 0.26vw;
      background: $ThemeColor;
    }
    &::after {
      content: "";
      flex: 1;
      height: 0.21vw;
      border-radius: 0.26vw;
      background: $ThemeColor;
      margin-left: 0.21vw;
    }
  }
}

@media (min-width: 1920px) {
  $LiWidth: 74px;
  .CompanyProfile {
    position: relative;
    .c-box {
      .b_title {
        position: relative;
        .t_cn {
          font-size: 24px;
          line-height: 40px;
          color: #333333;
        }
        .t_en {
          height: 30px;
          padding: 20px 0;
          position: relative;
          i {
            position: absolute;
            top: 50%;
            left: 0;
            margin: -4px 0 0 0;
          }
          span {
            font-size: 18px;
            line-height: 30px;
            color: #666666;
            padding: 0 0 0 80px;
          }
        }
      }
    }
    .box-company-profile {
      position: relative;
      .b_space_text {
        width: 1400px;
        min-height: 584px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 30px 0 40px 0;
        .b_content {
          padding: 0 0 20px 0;
          line-height: 30px;
          text-indent: 36px;
          font-size: 16px;
          .c_text,
          /deep/ div {
            font-size: 16px;
            text-indent: 36px;
            line-height: 30px;
            color: #333333;
          }
        }
        .b_data {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          position: relative;
          .data_item {
            flex: 1;
            position: relative;
            text-align: center;
            .item_tit {
              height: 30px;
              margin: 0 auto;
              text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
              .data_txt {
                display: block;
                font-size: 18px;
                line-height: 30px;
                color: #333333;
              }
            }
            .item_num {
              width: 100%;
              text-align: center;
              // padding: 10px 0 0 0;
              .i_data {
                font-size: 36px;
                font-weight: bold;
                color: #83bb26;
              }
              .i_danwei {
                padding: 0 0 0 6px;
                font-size: 20px;
                font-weight: bold;
                color: #83bb26;
              }
            }
          }
        }
      }
      .b_space_img {
        width: 1400px;
        margin: 0 auto;
        .s_bigImg {
          padding: 40px 0;
          .item_img {
            float: left;
            position: relative;
            &.item_img1 {
              width: 752px;
              height: 362px;
            }
            &.item_img2 {
              width: 618px;
              height: 362px;
              box-sizing: border-box;
              margin: 0 0 0 30px;
              border: 7px solid #eeeeee;
              cursor: pointer;
              &:hover {
                border: 7px solid $ThemeColor;
              }
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .btn-play {
              display: block;
              width: 36px;
              height: 36px;
              position: absolute;
              top: 50%;
              left: 50%;
              margin: -18px 0 0 -18px;
              border: solid 1px #008737;
              border-radius: 50%;
            }
          }
        }
        .s_environmentImg {
          position: relative;
          width: 1416px;
          min-height: 312px;
          .environmentImg {
            margin: 0 15px 0 0;
            cursor: pointer;
            &:hover {
              .box_img img {
                transform: scale(1.1, 1.1);
              }
              .imgDesc {
                color: #ffffff;
                background-color: $ThemeColor;
              }
            }
            .box_img {
              width: 100%;
              height: 256px;
              overflow: hidden;
              img {
                width: 100%;
                display: block;
                transition: 0.6s ease-in-out;
              }
            }
            .imgDesc {
              width: 100%;
              height: 56px;
              line-height: 56px;
              text-indent: 20px;
              font-size: 16px;
              color: #333333;
              background-color: #eeeeee;
              text-align: center;
            }
          }
          .swiperBtn {
            width: 40px;
            height: 70px;
            cursor: pointer;
            position: absolute;
            top: 50%;
            margin-top: -35px;
            z-index: 66;
            &.swiperBtn_left {
              left: 0;
              background: rgba($color: #c2c3be, $alpha: 0.5)
                url("../../assets/images/common/btn_left.png");
              background-size: cover;
              &:hover {
                background: rgba($color: #fff, $alpha: 0.5)
                  url("../../assets/images/common/btn_left.png");
                background-size: cover;
              }
            }
            &.swiperBtn_right {
              right: 16px;
              background: rgba($color: #c2c3be, $alpha: 0.5)
                url("../../assets/images/common/btn_right.png");
              background-size: cover;
              &:hover {
                background: rgba($color: #fff, $alpha: 0.5)
                  url("../../assets/images/common/btn_right.png");
                background-size: cover;
              }
            }
          }
        }
      }
    }
    .box-brand-profile {
      width: 1400px;
      margin: 0 auto;
      box-sizing: border-box;
      padding: 40px 0 40px 0;
      .BrandList {
        position: relative;
        .item_Brand {
          $item_Brand_width: 445px;
          $item_Brand_height: 246px;
          float: left;
          width: $item_Brand_width;
          height: $item_Brand_height;
          margin: 0 30px 20px 0;
          position: relative;
          cursor: pointer;
          &:nth-child(3n) {
            margin: 0 0 0 0;
          }
          &:hover {
            .i_info {
              z-index: 66;
            }
          }
          .i_cont {
            width: $item_Brand_width - 80px;
            height: $item_Brand_height - 60px;
            padding: 30px 40px;
            position: absolute;
            top: 0;
            left: 0;
            background-color: #eeeeee;
            img {
              display: block;
              height: 73px;
              margin: 20px auto 0;
            }
            .i_title {
              padding: 30px 0 0 0;
              font-size: 24px;
              color: #333333;
              text-align: center;
            }
          }
          .i_info {
            width: $item_Brand_width - 80px;
            height: $item_Brand_height - 60px;
            padding: 30px 40px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -6;
            background-color: #87c31e;
            i {
              display: block;
              width: 40px;
              height: 6px;
              background-color: #ffffff;
              border-radius: 3px;
              margin: 16px 0 26px;
            }
            .i_tit {
              color: #ffffff;
              font-size: 24px;
              line-height: 30px;
            }
            .i_text {
              color: #ffffff;
              font-size: 16px;
              line-height: 24px;
            }
          }
        }
      }
    }
    .box-enterprise-advantage {
      min-height: 606px - 40px;
      padding: 40px 0 0 0;
      position: relative;
      .b_cont {
        width: 1400px;
        margin: 0 auto;
        .advantageList {
          .item_advantage {
            float: left;
            width: 445px - 68px;
            min-height: 410px - 60px;
            padding: 30px 34px;
            margin: 0 30px 0 0;
            background-color: #ffffff;
            border-radius: 30px 0px 30px 0px;
            &:nth-child(3n) {
              margin: 0;
            }
            i {
              display: block;
              width: 36px;
              height: 5px;
              background-color: #87c31e;
              border-radius: 3px;
              margin: 10px 0 20px;
            }
            .i_icon {
              display: block;
              width: 54px;
              padding: 0 0 20px 0;
            }
            .i_title {
              font-size: 24px;
              line-height: 30px;
              color: #333333;
            }
            .i_desc {
              font-size: 16px;
              line-height: 24px;
              text-indent: 32px;
              color: #666666;
              text-align: justify;
              display: -webkit-box;
              text-overflow: ellipsis; /*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 8;
              overflow: hidden;
            }
          }
        }
      }
    }
    .box-cooperative-partner {
      width: 1400px;
      margin: 0 auto;
      padding: 40px 0 60px 0;
      position: relative;
      .decoration1 {
        display: block;
        width: 45px;
        height: 45px;
        border-radius: 50%;
        border: 20px solid #ffb103;
        position: absolute;
        top: -43px;
        right: 0;
        z-index: 6;
      }
      .cont {
        margin: 60px 0 0 0;
        min-height: 322px;
        position: relative;
        img {
          width: 100%;
        }
      }
    }

    .unLine {
      display: flex;
      width: $LiWidth;
      height: 4px;
      box-sizing: border-box;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 8px;
        height: 4px;
        border-radius: 5px;
        background: $ThemeColor;
      }
      &::after {
        content: "";
        flex: 1;
        height: 4px;
        border-radius: 5px;
        background: $ThemeColor;
        margin-left: 4px;
      }
    }
  }
}
</style>
